<template>
  <div class="autorefill">

    <transition name="fade">
      <grid-loader :done="httpSuccess" @complete="success" class="autorefill-loading" v-if="loading"/>
      <auto-refill-success v-if="!loading && status === 'success'" @close="$emit('close')" />
    </transition>

    <transition name="fade">
      <auto-refill-values
        @next="gotoCC"
        @close="$emit('close')"
        v-if="step === 1 && !options.status" />
      <card-list
        v-if="step === 2 || options.status"
        :requiresSave="true"
        title="Auto refill"
        :buttonTitle="options.status ? 'Update' : 'Enable auto refill'"
        :showLoading="options.status"
        :selected="options.source"
        @proceed="handleAutoRefillEnable"
        @load="loading = false"
        @cancel="$emit('close')" />
    </transition>
  </div>
</template>

<script>
import CardList from './../CardList'
import AutoRefillValues from './AutoRefillValues'
import GridLoader from '@/components/shared/loaders/GridLoader'
import AutoRefillSuccess from './auto-refill-state/Success'
import AutoRefillFailed from './auto-refill-state/Failed'

export default {
  name: 'AutoRefill',
  components: { CardList, GridLoader, AutoRefillValues, AutoRefillSuccess, AutoRefillFailed},
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      step: 1,
      autoRefill: {
        minimum: '',
        amount: '',
        source: '',
        transaction: null
      },
      status: 0,
      loading: false,
      httpSuccess: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    gotoCC (options) {
      this.autoRefill.minimum = options.minimum
      this.autoRefill.amount = options.amount
      this.loading = true
      this.step = 2
    },
    success () {
      this.loading = false
      this.autoRefill.minimum = parseInt(this.autoRefill.minimum)
      this.autoRefill.amount = parseInt(this.autoRefill.amount)
      this.$emit('complete', this.autoRefill)
    },
    handleAutoRefillEnable (data) {
      this.loading = true
      this.autoRefill.source = data.id
      this.$http.post(this.$api.payments.autoRefill, {
        minimum: this.autoRefill.minimum,
        amount: this.autoRefill.amount,
        cardId: data.id
      }).then(response => {
        console.log(response.data)
        this.autoRefill.transaction = response.data.transaction
        this.httpSuccess = true
        this.status = 'success'
      }, _ => {
        this.loading = false
        this.status = 'failed'
      })
    }
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" scoped>

  .autorefill-loading {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9999999;
      height: 100vh;
      width: 100%;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

  .autorefill-pending {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999999;
  }

  .loader {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
  }

  .autorefill {
    height: 100vh;
    position: relative;
  }

  .autorefill-loaded {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .p-header {
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //background-color: #f5f9ff;
    box-sizing: border-box;
    color: $text-light;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
    padding-bottom: 40px;
  }

  .inputs {
    height: 350px;
    width: 100%;
    right: 0px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    flex-grow: 1;
    box-sizing: border-box;
    justify-self: stretch;
    box-shadow: 0px -2px 12px 0px rgba($text-light, 0.1);
    background-color: white;
    padding: 40px;


    .active {
      width: 100%;

      span {
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;
        text-align: center;
        display: block;
        width: 100%;
        padding: 10px 0px;
      }

      button:last-child {
        margin-top: 10px !important;
        margin-left: 0px;
      }
    }

    .dg-input {
      margin-bottom: 10px;
    }

    h1 {
      margin-top: 0;
      font-weight: 600;
      font-size: 12px;
      color: $text-light;
      text-transform: uppercase;
      margin-bottom: 20px;
    }

    button {
      margin-top: 50px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/auto-refill/AutoRefill.vue